import * as React from 'react';
import { MasonryProps } from '../Masonry.types';
import TPAGallery from '../../TPAGallery/viewer/TPAGallery';

const Masonry: React.FC<MasonryProps> = props => {
  return <TPAGallery {...props}></TPAGallery>;
};

export default Masonry;
